/**
 * Anzeigenbereich für Thumbnails aller freigegebenen Bilder zu einem Vorgang
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { Panel } from 'react-bootstrap';

import { IResponse, IThumbnail, IThumbnailsResponse } from '../../models/ApiTypes';
import { bind, inject } from '../../utils/decorators';
import { ApiStore } from '../../stores/ApiStore';
// import FaIcon from '../site/FaIcon';

export interface IThumbnailListItemProps {
  id: string;
  thumbnail: IThumbnail;
}

export class ThumbnailItem extends React.Component<IThumbnailListItemProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  render() {
    let { thumbnail, id } = this.props;
    let downloadUrl = this.apiStore.vorgangDokumentDownloadUrl(id, thumbnail.eintrag_guid);
    let previewUrl = this.apiStore.vorgangThumbnailPreviewUrl(id, thumbnail.eintrag_guid);

    return (
        <a href={downloadUrl} target="_blank"><img src={previewUrl} className="img-thumbnail foto-thumb"/></a>
      );
  }

}

interface IThumbnailListProps {
  id: string;
  header?: 'headline' | 'panel';
}

@observer
export default class ThumbnailList extends React.Component<IThumbnailListProps, {}> {

  static defaultProps: Partial<IThumbnailListProps> = {
    header: 'panel'
  };

  @observable thumbnails: IThumbnail[];
  @inject(ApiStore) apiStore: ApiStore;

  async componentDidMount() {
    this.refresh();
  }

  async refresh() {
    let response: IResponse<IThumbnailsResponse>;
    response = await this.apiStore.vorgangThumbnails(this.props.id);
    if (response && response.ok) {
      this.setThumbnails(response.json);
    }
  }

  @action setThumbnails(thumbnails: IThumbnailsResponse) {
    this.thumbnails = thumbnails;
  }

  stringToDate(datumDE: string) {
    const elemente = datumDE.match(/(\d+)/ig);
    if (elemente) {
      return new Date(parseInt(elemente[2], 10), parseInt(elemente[1], 10) - 1, parseInt(elemente[0], 10),  parseInt(elemente[3], 10),  parseInt(elemente[4], 10),  parseInt(elemente[5], 10));
    } else {
      return undefined;
    }
  }

  @bind datumsvergleich(a: IThumbnail, b: IThumbnail) {
    const d1 = this.stringToDate(a.erfasstam);
    const d2 = this.stringToDate(b.erfasstam);
    if (d1 && d2) {
      return d2.getTime() - d1.getTime();
    } else {
      return 0;
    }
  }

  render() {
    const { id, header} = this.props;
    const headlineText = 'Hochgeladene Fotos';
    return (
      <div>
        {header === 'headline' && <h3>{headlineText}</h3>}
        <Panel header={header === 'panel' && headlineText}>
          <div style={{textAlign: 'center'}}>
            {!this.thumbnails ? (
              <span>Lade Bilder...</span>
            ) : (this.thumbnails.length === 0) ? (
              <span>Noch keine Bilder hochgeladen</span>
            ) : this.thumbnails.sort(this.datumsvergleich).map((thumbnail, index) => <ThumbnailItem key={index} id={id} thumbnail={thumbnail}  />)}
          </div>
        </Panel>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/dokumente/ThumbnailList.tsx